"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EmptyAlert = ({ textualContent }) => {
    return (react_1.default.createElement("div", { className: "empty-alert-container" },
        react_1.default.createElement("div", { className: "empty-alert-content-body" },
            react_1.default.createElement("div", { className: "empty-alert-icon-container" },
                react_1.default.createElement("span", { className: "icon-info-square empty-alert-icon" })),
            react_1.default.createElement("div", { className: "empty-alert-textual-container" },
                react_1.default.createElement("p", null, textualContent)))));
};
exports.default = EmptyAlert;
